module.exports = __webpack_public_path__ + "static/img/15areaB_2.8ecb129.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/15areaB_2.png
// module id = 1124
// module chunks = 1